import './App.css'
import Router from './routes'
import { QueryClient, QueryClientProvider } from 'react-query'
// import RouterWithGrowthbook from './growthbook';
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import 'react-quill-new/dist/quill.core.css'
import { persistor, store } from 'store'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { ErrorBoundary } from '@echoteam/signoz-react';
import {useEffect} from 'react'

function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false
      }
    }
  })

  useEffect(() => {
    const isMacChrome = () => {
      const ua = navigator.userAgent;

      const isChrome = ua.includes('Chrome') && !ua.includes('Edg') && !ua.includes('OPR');
      const isMac = /Macintosh|MacIntel|MacPPC|Mac68K/.test(ua);

      return isChrome && isMac;
    };

    if (isMacChrome()) {
      document.body.classList.add('is-mac-chrome');
    }
  }, []);

  return (
    <ErrorBoundary>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <QueryClientProvider client={queryClient}>
            <ToastContainer
              closeButton={false}
              limit={3}
              position={'top-center'}
              autoClose={2000}
              hideProgressBar={false}
              closeOnClick={true}
              pauseOnHover={true}
              theme={'light'}
            />
            <Router />
          </QueryClientProvider>
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  )
}

export default App;
